import '../i18n';
import '../stylesheets/contact.css';

import moment from 'moment';
import React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';

import { getBadgesByContactId } from '../actions/badges';
import { getBoatsByContactId } from '../actions/boats';
import {
  createContact,
  deleteContact,
  getContact,
  getMyContactTypes,
  updateContact,
} from '../actions/contacts';
import { getBoatDocuments } from '../actions/documents';
import { getMooringsByContactId } from '../actions/moorings';
import { getWaitingContactsByContactId } from '../actions/waiting_contacts';
import CountrySelector from '../components/CountrySelector';
import EditBadgeModal from '../components/EditBadgeModal';
import EditBoatModal from '../components/EditBoatModal';
import EditWaitingContactModal from '../components/EditWaitingContactModal';
import { COMMUNICATION_LANGUAGES } from '../constants/constants';
import globalStyles from '../stylesheets/globalStyles';
// import { validateRegisterform } from '../utils/validators';
import { validateCreateContactForm } from '../utils/validators';
import AddNewButton from './AddNewButton';
import DocumentMaintainArea from './DocumentMaintainArea';
import FormInput from './FormInput';
import StatusAlerts from './StatusAlerts';

const i18nPrefix = 'EditContactModal';

function BoatDocumentsIcon({ title }) {
  return (
    <span className='contact-boats__documents' title={title} aria-label={title}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        width='18'
        height='18'
        aria-hidden='true'
        focusable='false'>
        <path
          fill='currentColor'
          d='M6 2.25h7.2L19.5 8.4V20.25a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5V3.75A1.5 1.5 0 0 1 6 2.25Zm6.75 1.5v4.2h4.35l-4.35-4.2ZM8.25 12.75h7.5v1.5h-7.5v-1.5Zm0 3.5h7.5v1.5h-7.5v-1.5Z'
        />
      </svg>
    </span>
  );
}

const emptyContact = {
  rights: {
    read: false,
    edit: false,
    delete: false,
  },
};

class EditContactModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      create: false, //Are we creating or editing a contact
      loading: false,
      success: false,
      error: false,
      contact: emptyContact,
      contact_types: [],
      boats: [],
      boatsWithDocuments: {},
      moorings: [],
      waiting_contacts: [],
      badges: [],
    };

    this.EditWaitingContactModal = React.createRef();
  }

  componentDidMount() {
    this.props.onRef && this.props.onRef(this);

    getMyContactTypes(
      (contact_types) => {
        this.setState({ contact_types: contact_types });
      },
      (error) => {},
    );

    // Load from props
    if (this.props.contact) {
      this.setState({ contact: this.props.contact, create: false });
    } else {
      this.setState({
        create: true,
        boats: [],
        moorings: [],
        waiting_contacts: [],
        badges: [],
      });
    }
  }

  loadBoats = (contact = this.state.contact) => {
    getContact(contact.id, (contact) =>
      this.setState({ contact: contact }, () => {}),
    );
    getBoatsByContactId(
      contact.id,
      (boats) => {
        const list = boats || [];
        this.setState({ boats: list, boatsWithDocuments: {} });
        this.loadBoatDocumentFlags(list);
      },
      () => {},
    );
    getMooringsByContactId(
      contact.id,
      (moorings) => {
        moorings.sort((a, b) =>
          moment(a.assigned_contact.to_date) <
          moment(b.assigned_contact.to_date)
            ? 1
            : -1,
        );
        this.setState({ moorings: moorings });
      },
      () => {},
    );
    getWaitingContactsByContactId(
      contact.id,
      (waiting_contacts) => {
        this.setState({ waiting_contacts: waiting_contacts });
      },
      () => {},
    );
    const accountData = JSON.parse(localStorage.getItem('AccountData')) || {};
    const showBadgeManagement =
      accountData.show_badge_management === 1 ||
      accountData.show_badge_management === '1' ||
      accountData.show_badge_management === true;

    if (showBadgeManagement) {
      getBadgesByContactId(
        contact.id,
        (badges) => {
          this.setState({ badges: badges || [] });
        },
        () => {},
      );
    }
  };

  loadBoatDocumentFlags = (boats) => {
    const requestId = (this.boatDocumentsRequestId || 0) + 1;
    this.boatDocumentsRequestId = requestId;
    const list = boats || [];
    if (list.length === 0) {
      this.setState({ boatsWithDocuments: {} });
      return;
    }

    const boatsWithDocuments = {};
    let pending = list.length;
    const finishOne = (id, hasDocuments) => {
      if (this.boatDocumentsRequestId !== requestId) return;
      if (id != null) boatsWithDocuments[id] = hasDocuments;
      pending -= 1;
      if (pending === 0) {
        this.setState({ boatsWithDocuments });
      }
    };

    list.forEach((boat) => {
      if (!boat?.id) {
        finishOne(boat?.id, false);
        return;
      }
      getBoatDocuments(
        boat.id,
        (docs) => finishOne(boat.id, Array.isArray(docs) && docs.length > 0),
        () => finishOne(boat.id, false),
      );
    });
  };

  show = (contact) => {
    if (contact) {
      this.setState({ contact: contact, show: true, create: false });
      this.loadBoats(contact);
    } else {
      this.setState({ contact: {}, show: true, create: true });
    }
  };
  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.props.onClose && this.props.onClose();
    this.setState({
      show: false,
      contact: emptyContact,
      edit: false,
      success: false,
      error: false,
    });
  };

  handleSave = () => {
    this.props.onSave && this.props.onSave();
    this.handleClose();
  };

  hide = () => {
    this.setState({ show: false });
  };
  unhide = () => {
    this.setState({ show: true });
  };

  createContactClicked = () => {
    const formErrors = validateCreateContactForm(this.state.contact);
    const noErrors = Object.values(formErrors).every((x) => x == false);
    if (!noErrors) {
      this.setState({
        error: true,
        errorMessage: this.props.t('errors.someValuesAreNotCorrect'),
      });
      return;
    } else {
      //no form errors
      this.setState({ loading: true, success: false, error: false }, () => {
        createContact(
          this.state.contact,
          () => {
            this.setState({
              loading: false,
              success: true,
              error: false,
            });
            this.handleSave();
          },
          (error) => {
            const errorMessage = this.props.t(
              `errors.${error.response.data.language_variable}`,
            );
            this.setState({
              loading: false,
              success: false,
              error: true,
              errorMessage: errorMessage,
            });
          },
        );
      });
    }
  };

  editContactClicked = () => {
    const formErrors = validateCreateContactForm(this.state.contact);
    const noErrors = Object.values(formErrors).every((x) => x == false);
    if (!noErrors) {
      this.setState({
        error: true,
        errorMessage: this.props.t('errors.someValuesAreNotCorrect'),
      });
      return;
    } else {
      //no form errors
      this.setState({ loading: true, success: false, error: false }, () => {
        updateContact(
          this.state.contact,
          () => {
            this.setState({
              loading: false,
              success: true,
              error: false,
            });
            this.handleSave();
          },
          (error) => {
            const errorMessage = this.props.t(
              `errors.${error.response.data.language_variable}`,
            );
            this.setState({
              loading: false,
              success: false,
              error: true,
              errorMessage: errorMessage,
            });
          },
        );
      });
    }
  };

  deleteContactClicked = () => {
    window.confirm(this.props.t(`${i18nPrefix}.areYouSureDeleteContact`)) &&
      deleteContact(
        this.state.contact.id,
        () => {
          this.setState({ loading: false, success: true, error: false });
          this.handleSave();
        },
        (err) => {},
      );
  };

  reloadBadges = () => {
    if (!this.state.contact?.id) return;
    const accountData = JSON.parse(localStorage.getItem('AccountData')) || {};
    const showBadgeManagement =
      accountData.show_badge_management === 1 ||
      accountData.show_badge_management === '1' ||
      accountData.show_badge_management === true;
    if (!showBadgeManagement) return;

    getBadgesByContactId(
      this.state.contact.id,
      (badges) => {
        this.setState({ badges: badges || [] });
      },
      () => {},
    );
  };

  onOpenBadgeTableClicked = () => {
    if (!this.state.contact?.id) {
      this.props.history.push('/BadgeTable');
      return;
    }

    this.props.history.push('/BadgeTable', {
      contact_id: this.state.contact.id,
    });
  };

  render() {
    const { t } = this.props;
    const languages = COMMUNICATION_LANGUAGES;
    const formatDate = (value) =>
      value ? moment(value).format(t('global.dateFormat')) : '-';
    const actionButtonStyle = {
      ...globalStyles.normalButton,
      width: 'auto',
      height: 'auto',
      margin: 0,
      padding: '4px 10px',
    };

    const formErrors = validateCreateContactForm(this.state.contact);

    const role = localStorage.getItem('role');
    const management = role == 'management';
    const accountData = JSON.parse(localStorage.getItem('AccountData')) || {};
    const showBadgeManagement =
      accountData.show_badge_management === 1 ||
      accountData.show_badge_management === '1' ||
      accountData.show_badge_management === true;

    return (
      <>
        <EditBoatModal
          onRef={(ref) => {
            this.EditBoatModal = ref;
          }}
          onClose={() => {
            this.loadBoats();
            this.unhide();
          }}
          contact_id={this.state.contact.id}
        />
        <EditWaitingContactModal
          onRef={(ref) => (this.EditWaitingContactModal = ref)}
          // onClose={this.loadBoats()}
        />
        <EditBadgeModal
          onRef={(ref) => (this.EditBadgeModal = ref)}
          onSave={this.reloadBadges}
        />

        <Modal
          size='lg'
          show={this.state.show}
          onHide={this.handleClose}
          animation={true}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.create
                ? t(`${i18nPrefix}.createContact`)
                : t(`${i18nPrefix}.editContact`)}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <StatusAlerts
              state={this.state}
              errorMessage={this.state.errorMessage}
            />

            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.salutation`)}
                  value={this.state.contact.salutation}
                  error={formErrors.salutation}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        salutation: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}></Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.firstName`)}
                  value={this.state.contact.firstname}
                  error={formErrors.firstname}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        firstname: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.lastName`)}
                  value={this.state.contact.lastname}
                  error={formErrors.lastname}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        lastname: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormInput
                  as='select'
                  label={t(`${i18nPrefix}.communicationLanguage`)}
                  value={this.state.contact.communication_language}
                  error={formErrors.communication_language}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        communication_language: event.target.value,
                      },
                    });
                  }}>
                  <option value={null}></option>

                  {languages.map((language, index) => (
                    <option key={index} value={language}>
                      {language}
                    </option>
                  ))}
                </FormInput>
              </Col>
              <Col md={6}>
                <FormInput
                  as='select'
                  label={t(`${i18nPrefix}.type`)}
                  value={this.state.contact.type}
                  error={formErrors.type}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        type: event.target.value,
                      },
                    });
                  }}>
                  <option value={null}></option>

                  {this.state.contact_types.map((contact_type) => (
                    <option key={contact_type.id} value={contact_type.type}>
                      {contact_type.type}
                    </option>
                  ))}
                </FormInput>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.email`)}
                  error={formErrors.email}
                  value={this.state.contact.email}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        email: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  type='tel'
                  label={t(`${i18nPrefix}.mobile`)}
                  value={this.state.contact.mobile}
                  error={formErrors.mobile}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        mobile: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.street`)}
                  value={this.state.contact.street}
                  error={formErrors.street}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        street: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.city`)}
                  value={this.state.contact.city}
                  error={formErrors.city}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        city: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.zip`)}
                  value={this.state.contact.zip}
                  error={formErrors.zip}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        zip: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}>
                <CountrySelector
                  label={t(`${i18nPrefix}.country`, 'Country')}
                  value={this.state.contact.country}
                  onChange={(value) => {
                    console.log(value);
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        country: value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.phone_p`)}
                  value={this.state.contact.phone_p}
                  error={formErrors.phone_p}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        phone_p: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.phone_b`)}
                  value={this.state.contact.phone_b}
                  error={formErrors.phone_b}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        phone_b: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormInput
                  type='date'
                  label={t(`${i18nPrefix}.birthday`)}
                  value={this.state.contact.birthday}
                  error={formErrors.birthday}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        birthday: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}></Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.alternative_email`)}
                  value={this.state.contact.alternative_email}
                  error={formErrors.alternative_email}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        alternative_email: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.alternative_mobile`)}
                  value={this.state.contact.alternative_mobile}
                  error={formErrors.alternative_mobile}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        alternative_mobile: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.access_badge`)}
                  value={this.state.contact.access_badge}
                  error={formErrors.access_badge}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        access_badge: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.vat`)}
                  value={this.state.contact.vat}
                  error={formErrors.vat}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        vat: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormInput
                  as='textarea'
                  type='text'
                  label={t(`${i18nPrefix}.remarks`)}
                  value={this.state.contact.remarks}
                  error={formErrors.remarks}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        remarks: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.boatparkAccount`)}
                  value={this.state.contact.account_email}
                  // error={formErrors.remarks}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        account_email: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.customer_number`)}
                  value={this.state.contact.customer_number}
                  // error={formErrors.remarks}
                  onChange={(event) => {
                    this.setState({
                      contact: {
                        ...this.state.contact,
                        customer_number: event.target.value,
                      },
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.id`)}
                  value={this.state.contact.id}
                  disabled
                />
              </Col>
              <Col md={6}>
                <FormInput
                  type='text'
                  label={t(`${i18nPrefix}.token`)}
                  value={this.state.contact.token}
                  disabled
                />
              </Col>
            </Row>

            <h3 className='contact-modal__section-title'>
              {t(`${i18nPrefix}.boats`)}
            </h3>
            {!this.state.create && this.state.boats.length > 0 && (
              <div className='contact-entities__table'>
                <div className='contact-entities__row contact-entities__row--header contact-boats__row'>
                  <div>{t('FastBooking.boat', 'Boat')}</div>
                  <div>{t('EditBoatModal.make', 'Make')}</div>
                  <div>{t(`${i18nPrefix}.dimensions`, 'Dimensions')}</div>
                  <div className='contact-entities__actions-title'>
                    {t('global.action', 'Action')}
                  </div>
                </div>
                {this.state.boats.map((boat) => (
                  <div
                    key={boat.id}
                    className='contact-entities__row contact-boats__row'>
                    <div>
                      {[boat.registration_number, boat.name].filter(Boolean).join(' / ') || '-'}
                    </div>
                    <div>{boat.make || '-'}</div>
                    <div>{`${boat.length?.toFixed(2)} / ${boat.beam?.toFixed(2)}`}</div>
                    <div className='contact-entities__actions'>
                      {this.state.boatsWithDocuments[boat.id] && (
                        <BoatDocumentsIcon
                          title={t('EditBoatModal.documents', 'Documents')}
                        />
                      )}
                      <Button
                        className='contact-modal__action-btn'
                        style={actionButtonStyle}
                        onClick={() => {
                          this.EditBoatModal.show(boat);
                        }}>
                        {management
                          ? t(`${i18nPrefix}.edit`)
                          : t(`${i18nPrefix}.show`)}
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {!this.state.create && this.state.boats.length === 0 && (
              <div className='contact-entities__empty'>
                {t('EditContactModal.noBoats', 'No boats yet')}
              </div>
            )}

            {!this.state.create && management && (
              <AddNewButton
                center
                onClick={() => {
                  this.EditBoatModal.show();
                }}
                label={t(`${i18nPrefix}.addNewBoat`)}
              />
            )}

            <h3 className='contact-modal__section-title'>
              {t(`${i18nPrefix}.moorings`)}
            </h3>

            {!this.state.create && this.state.moorings.length > 0 && (
              <div className='contact-entities__table'>
                <div className='contact-entities__row contact-entities__row--header contact-moorings__row'>
                  <div>{t(`${i18nPrefix}.berth`, 'Berth')}</div>
                  <div>{t(`${i18nPrefix}.zone`, 'Zone')}</div>
                  <div>{t(`${i18nPrefix}.type`, 'Type')}</div>
                  <div>{t(`${i18nPrefix}.dimensions`, 'Dimensions')}</div>
                </div>
                {this.state.moorings.map((mooring) => {
                  const active =
                    moment(mooring.assigned_contact.from_date) < moment() &&
                    moment(mooring.assigned_contact.to_date) > moment();

                  return (
                    <div
                      key={mooring.mooring_id}
                      className={`contact-entities__row contact-moorings__row ${!active ? 'contact-entities__row--inactive' : ''}`}>
                      <div>
                        <a
                          style={{
                            textDecoration: 'none',
                            color: 'black',
                          }}
                          href={`/home/mooringdetails/${mooring.mooring_id}`}
                          target='_blank'
                          rel='noreferrer'>
                          {mooring.berth_number}
                        </a>
                      </div>
                      <div>{mooring.mooring_zone || '-'}</div>
                      <div>{mooring.mooring_type || '-'}</div>
                      <div>
                        {`${parseFloat(mooring.max_length).toFixed(2)} / ${parseFloat(mooring.max_beam).toFixed(2)} / ${parseFloat(mooring.max_draught).toFixed(2)}`}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {!this.state.create && this.state.moorings.length === 0 && (
              <div className='contact-entities__empty'>
                {t('EditContactModal.noMoorings', 'No moorings yet')}
              </div>
            )}

            <h3 className='contact-modal__section-title'>
              {t(`${i18nPrefix}.watiting_contacts`)}
            </h3>
            {!this.state.create && this.state.waiting_contacts.length > 0 && (
              <div className='contact-entities__table'>
                <div className='contact-entities__row contact-entities__row--header contact-waiting__row'>
                  <div>{t(`${i18nPrefix}.entryDate`, 'Entry date')}</div>
                  <div>{t(`${i18nPrefix}.zone`, 'Zone')}</div>
                  <div>{t(`${i18nPrefix}.type`, 'Type')}</div>
                  <div className='contact-entities__actions-title'>
                    {t('global.action', 'Action')}
                  </div>
                </div>
                {this.state.waiting_contacts.map((waiting_contact) => {
                  const inactive = !!waiting_contact.archived;
                  return (
                    <div
                      key={
                        waiting_contact.id ||
                        waiting_contact.getMooringsByContactId
                      }
                      className={`contact-entities__row contact-waiting__row ${inactive ? 'contact-entities__row--inactive' : ''}`}>
                      <div>{formatDate(waiting_contact.entry_date)}</div>
                      <div>{waiting_contact.mooring_zone || '-'}</div>
                      <div>{waiting_contact.mooring_type || '-'}</div>
                      <div className='contact-entities__actions'>
                        <Button
                          className='contact-modal__action-btn'
                          style={actionButtonStyle}
                          onClick={() =>
                            this.EditWaitingContactModal.show(waiting_contact)
                          }>
                          {management
                            ? t(`${i18nPrefix}.edit`)
                            : t(`${i18nPrefix}.show`)}
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {!this.state.create && this.state.waiting_contacts.length === 0 && (
              <div className='contact-entities__empty'>
                {t(
                  'EditContactModal.noWaitingContacts',
                  'No waiting contacts yet',
                )}
              </div>
            )}

            {showBadgeManagement && (
              <>
                <h3 className='contact-modal__section-title'>
                  {t(`${i18nPrefix}.badges`, 'Badges')}
                </h3>
                {!this.state.create && this.state.badges.length > 0 && (
                  <div className='contact-entities__table'>
                    <div className='contact-entities__row contact-entities__row--header contact-badges__row'>
                      <div>
                        {t('EditBadgeModal.badgeNumber', 'Badge number')}
                      </div>
                      <div>{t('EditBadgeModal.issueDate', 'Issue date')}</div>
                      <div>
                        {t('EditBadgeModal.depositAmount', 'Deposit amount')}
                      </div>
                      <div>
                        {t('EditBadgeModal.redemptionDate', 'Redemption date')}
                      </div>
                      <div>
                        {t(
                          'EditBadgeModal.depositRefunded',
                          'Deposit refunded',
                        )}
                      </div>
                      <div className='contact-entities__actions-title'>
                        {t('global.action', 'Action')}
                      </div>
                    </div>

                    {this.state.badges.map((badge) => {
                      const active = !badge.redemption_date;

                      return (
                        <div
                          key={
                            badge.id ||
                            `${badge.badge_number}-${badge.issue_date}`
                          }
                          className={`contact-entities__row contact-badges__row ${!active ? 'contact-entities__row--inactive' : ''}`}>
                          <div>
                            <span className='contact-entities__tag'>
                              {badge.badge_number || '-'}
                            </span>
                          </div>
                          <div>{formatDate(badge.issue_date)}</div>
                          <div>{badge.deposit_amount ?? '-'}</div>
                          <div>{formatDate(badge.redemption_date)}</div>
                          <div>
                            {badge.deposit_refunded
                              ? t('global.YesOrNo.1', 'Yes')
                              : t('global.YesOrNo.0', 'No')}
                          </div>
                          <div className='contact-entities__actions'>
                            <Button
                              className='contact-modal__action-btn'
                              style={actionButtonStyle}
                              onClick={() => this.EditBadgeModal.show(badge)}>
                              {management
                                ? t(`${i18nPrefix}.edit`)
                                : t(`${i18nPrefix}.show`)}
                            </Button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {!this.state.create && this.state.badges.length === 0 && (
                  <div className='contact-entities__empty'>
                    {t('EditContactModal.noBadges', 'No badges yet')}
                  </div>
                )}

                {!this.state.create && management && (
                  <Row>
                    <Col md={12}>
                      <AddNewButton
                        center
                        onClick={() =>
                          this.EditBadgeModal.show({
                            contact_id: this.state.contact.id,
                            contact: this.state.contact,
                          })
                        }
                        label={t(`${i18nPrefix}.addNewBadge`, 'Add new badge')}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}

            <div style={{ width: '100%', height: 30 }}></div>

            <DocumentMaintainArea
              id_params={{ contact_id: this.state.contact.id }}
            />
          </Modal.Body>
          <Modal.Footer>
            {!this.state.create && this.state.contact.rights?.delete && (
              <Button
                style={globalStyles.deleteButton}
                disabled={this.state.loading}
                onClick={() => this.deleteContactClicked()}>
                {t(`${i18nPrefix}.deleteContact`)}
              </Button>
            )}
            {this.state.create && (
              <Button
                style={globalStyles.saveButton}
                disabled={this.state.loading}
                onClick={() => this.createContactClicked()}>
                {t(`${i18nPrefix}.createContact`)}
              </Button>
            )}
            {!this.state.create && this.state.contact.rights?.edit && (
              <Button
                style={globalStyles.saveButton}
                disabled={this.state.loading}
                onClick={() => this.editContactClicked()}>
                {t(`global.save`)}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withTranslation()(withRouter(EditContactModal));
